import { render, staticRenderFns } from "./TopRecognizers.vue?vue&type=template&id=0717531f"
import script from "./TopRecognizers.vue?vue&type=script&lang=js"
export * from "./TopRecognizers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports